import { render } from "./Matricula.vue?vue&type=template&id=8be494fc&scoped=true"
import script from "./Matricula.vue?vue&type=script&lang=js"
export * from "./Matricula.vue?vue&type=script&lang=js"

import "./Matricula.vue?vue&type=style&index=0&id=8be494fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be494fc"]])

export default __exports__